<template>
  <div class="running_bids">
    <div class="new_bidding">
      <ul class="bidding_card" v-if="myBidList.length">
        <router-link
          :to="`/bidding-detail/${myBid.biddingId}`"
          tag="li"
          class="card"
          v-for="(myBid,index) in myBidList"
          :key="index"
        >
          <div class="img_wrapper">
            <img :src="myBid.itemImage" v-if="myBid.itemImage" />
            <img src="../../../assets/images/dummy.png" alt="profile-image" v-else />
          </div>
          <div class="prod-detail">
            <p class="prod-name">{{myBid.itemName}}</p>
            <h5 class="bidding-price">
              <img src="../../../assets/images/detail/bidding-icon.svg" alt="profile-image" />​
              <span>{{Math.round(myBid.highestBidValue)}}</span>
              <img
                src="../../../assets/images/detail/m-cash.svg"
                alt
                class="mpoint"
                v-if="myBid.biddingCurrencyType === 'MPOINTS'"
              />
              <img
                src="../../../assets/images/detail/gems.svg"
                alt
                class="mpoint"
                v-if="myBid.biddingCurrencyType === 'GEMS'"
              />
            </h5>
          </div>
          <div v-if="myBid.biddingStatus === 'STARTED'">
            <p
              class="bidder-detail"
              v-if="myBid.userName && myBid.location"
            >{{$t('userIsWinning',{name:myBid.userName, location:myBid.location})}}</p>
            <p class="bidder-detail" v-if="myBid.userName && !myBid.location || myBid.location === 'null'">{{$t('userIsWinningWithoutLoc',{name:myBid.userName})}}</p>
          </div>
          <div v-if="myBid.biddingStatus === 'CLOSED'">
            <p class="bidder-detail-closed" v-if="myBid.userName && myBid.location">
              <img src="../../../assets/images/detail/ic_medal.svg" alt="profile-image" />
              {{$t('userWon',{name:myBid.userName, location: myBid.location})}}
            </p>
            <p class="bidder-detail-closed" v-if="myBid.userName && !myBid.location || myBid.location === 'null'">
              <img src="../../../assets/images/detail/ic_medal.svg" alt="profile-image" />
              {{$t('userWonWithoutLoc',{name:myBid.userName})}}
            </p>
          </div>
          <div class="time-trail">
            <p class="applied">
              {{$t('totalUserApplied')}} :
              <strong>{{myBid.totalUser}}</strong>
            </p>
            <p class="applied">
              <span v-if="myBid.biddingStatus === 'INACTIVE'">{{$t('bidStartTime')}} &nbsp;</span>
              <span v-if="myBid.biddingStatus === 'STARTED'">{{$t('timeLeft')}} &nbsp;</span>
              <span v-if="myBid.biddingStatus === 'CLOSED'">{{$t('biddingOver')}} &nbsp;</span>
              <span class="time" v-if="myBid.biddingStatus !== 'CLOSED'">
                <Timer :timing="getLiveTime(myBid.biddingEndTimeMillis)" @StopTime="timerStop" />
              </span>
            </p>
          </div>
        </router-link>
      </ul>
      <infinite-loading
        @infinite="myBidProd"
        spinner="circles"
        :class="{'visibilityHidden': noData}"
      >
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import "../../../assets/css/bidding.scss";
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
import Timer from "../../../components/Common/TimeCount";

export default {
  name: "MyBids",
  components: {
    Timer
  },
  data() {
    return {
      myBidList: [],
      myBidIndex: 0,
      loading: false,
      noData: false
      // timeExpired: false
    };
  },
  methods: {
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (!obj.timerShow) {
        // this.timeExpired = true
      }
    },
    myBidProd($state) {
      this.loading = false;
      ApiCaller(
        constant.GAMING_API_URL,
        "bidding/items/" + this.myBidIndex + "?biddingType=4",
        "get"
      )
        .then(data => {
          if (data.data.biddingResponseDTOs.length) {
            this.myBidList.push(...data.data.biddingResponseDTOs);
            this.myBidIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {}
};
</script>
<style scoped>
.my-bid-price {
  font-size: 0.813em;
  font-weight: 600;
  margin: 10px 0 0;
  color: #898989;
}
.my-bid-price span {
  color: #e81f1f;
}
</style>